/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.

==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'GridIcon',
    i18n: 'Dashboard',
    permissions: 'view-dashboard,view-quick-stats',
  },
  {
    header: 'General',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/companies',
        name: 'Companies',
        slug: 'tenants-list',
        icon: 'HomeIcon',
        i18n: 'Tenants',
        permissions: 'view-company,create-company,update-company',
      },
    ],
  },
  {
    header: 'Accounts',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/contacts',
        name: 'Contacts',
        slug: 'manage-pricing-tiers',
        icon: 'PhoneCallIcon',
        i18n: 'Pricing',
        permissions: 'view-contact,create-contact,update-contact',
      },
      {
        url: '/pages/locations',
        name: 'Locations',
        slug: 'manage-pricing-tiers',
        icon: 'MapPinIcon',
        i18n: 'Pricing',
        permissions: 'view-location,create-location,update-location',
      },
      {
        url: '/pages/buildings',
        name: 'Buildings',
        slug: 'manage-pricing-tiers',
        icon: 'GridIcon',
        i18n: 'Pricing',
        permissions: 'view-building,create-building,update-building',
      },
      {
        url: '',
        name: 'Opportunities',
        slug: 'manage-pricing-tiers',
        icon: 'SmileIcon',
        i18n: 'Pricing',
        permissions: 'view-opportunity,create-opportunity,update-opportunity',
      },
      {
        url: '/pages/actions',
        name: 'Actions',
        slug: 'actions-list',
        icon: 'TargetIcon',
        i18n: 'Pricing',
        permissions: 'view-action,create-action,update-action',
      },
    ]
  },
  {
    header: 'Risk',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/property-assessment',
        name: 'Property Assessment',
        slug: 'prospect-customers',
        icon: 'AlertTriangleIcon',
        i18n: 'Tenants',
        permissions: 'view-property-risk-assessment,create-property-risk-assessment',
      },
      {
        url: '/pages/cope-assessment',
        name: 'COPE Assessment',
        slug: 'cope-assessment',
        icon: 'AlertTriangleIcon',
        i18n: 'Tenants',
        permissions: 'create-cope-assessment,view-cope-assessment',
      },
      {
        url: '/pages/brewery-site-inspection',
        name: 'Brewery Inspection',
        slug: 'manage-pricing-tiers',
        icon: 'AlertTriangleIcon',
        i18n: 'Pricing',
        permissions: 'create-brewery-inspection,view-brewery-inspection',
      },
      {
        url: '/pages/hazard-inspection',
        name: 'Hazards Inspection',
        slug: 'hazard-inspection',
        icon: 'AlertTriangleIcon',
        i18n: 'Pricing',
        permissions: 'create-hazard-inspection,view-hazard-inspection',
      },
      {
        url: '/pages/food-safety-report',
        name: 'Food Safety Report',
        slug: 'prospect-customers',
        icon: 'AlertTriangleIcon',
        i18n: 'Tenants',
        permissions: 'view-food-safety-report,create-food-safety-report',
      },
    ]
  },
  {
    header: 'Organization Settings',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/manage-users',
        name: 'Manage Users',
        slug: 'manage-users',
        icon: 'UsersIcon',
        i18n: 'Pricing',
        permissions: 'view-user,create-user,update-user,view-user-role,create-user-role,update-user-role',
      },
      {
        url: '/pages/standard-actions',
        name: 'Standard Actions',
        slug: 'standard-actions',
        icon: 'CpuIcon',
        i18n: 'Pricing',
        permissions: 'create-standard-action,view-standard-action',
      },
      {
        url: '/pages/report-templates',
        name: 'Manage Templates',
        slug: 'manage-users',
        icon: 'FolderIcon',
        i18n: 'Pricing',
        permissions: 'public',
      },
      {
        url: '/pages/sf-data',
        name: 'SF DATA',
        slug: 'manage-ai-engine',
        icon: 'LockIcon',
        i18n: 'Pricing',
        permissions: 'public',
      },
    ]
  },
]
